import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=44a1ef88&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=44a1ef88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a1ef88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a1ef88')) {
      api.createRecord('44a1ef88', component.options)
    } else {
      api.reload('44a1ef88', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=44a1ef88&scoped=true&", function () {
      api.rerender('44a1ef88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jfjZTL3VBS3q/JS/comp/PopupBox.vue"
export default component.exports